// extracted by mini-css-extract-plugin
export default {"main":"Graph_main__S3QPN","activities":"Graph_activities__XEHcR","userGuest":"Graph_userGuest__rPFTs","explain":"Graph_explain__+niVx","chart":"Graph_chart__9Jocd"};